const removeTrailingSlash = (string: string): string => {
	if (string.endsWith('/')) {
		return string.replace(/\/$/, '');
	}
	return string;
};

/**
 * Checks if `path` is a parent of, or equal to, the `relativeTo` path.
 *
 * @example
 * checkCurrentPathAncestor('/a', '/a/b') === true
 */
export const checkCurrentPathAncestor = (path: string, relativeTo: string): boolean => {
	const pathRemoved = removeTrailingSlash(path);
	const realtiveToRemoved = removeTrailingSlash(relativeTo);

	return realtiveToRemoved === pathRemoved || realtiveToRemoved.startsWith(pathRemoved + '/');
};
